import React, { useState, useRef } from 'react'
import styles from './CategoryAdd.module.css'
import axios from "axios";
import Toggle from '../../utils/Toggle/Toggle';
import Spinner from '../Spinner/Spinner'
import {API} from '../../config'
import Popup from '../Popup/Popup';
import { useImageUpload } from '../ClientLogos/hooks/useImageUpload';

function CategoryAdd() {
  const [sort, setSort] = useState();
  const [name, setName] = useState();
  const [status, setStatus] = useState(false);
  const [description, setDescription] = useState();
  const [subDescription, setSubDescription] = useState();
  const [show, setShow] = useState(false);
  const [spin, setSpin] = useState(false);

  const {
    selectedFile: nonSelectedFile,
    imagePreview: nonSelectedPreview,
    uploadError: nonSelectedError,
    setUploadError: setNonSelectedError,
    handleFileChange: handleNonSelectedFileChange,
    uploadImage: uploadNonSelectedImage,
    resetImageState: resetNonSelected,
  } = useImageUpload();

  const {
    selectedFile: selectedFile,
    imagePreview: selectedPreview,
    uploadError: selectedError,
    setUploadError: setSelectedError,
    handleFileChange: handleSelectedFileChange,
    uploadImage: uploadSelectedImage,
    resetImageState: resetSelected,
  } = useImageUpload();

  const {
    selectedFile: customFile,
    imagePreview: customPreview,
    uploadError: customError,
    handleFileChange: handleCustomFileChange,
    uploadImage: uploadCustomImage,
    resetImageState: resetCustom,
  } = useImageUpload();

  const customRef = useRef(null);

  const change = () => {
    setShow(false);
  };

  const saveData = async (event) => {
    event.preventDefault();

    if (!nonSelectedFile) {
      setNonSelectedError("Please upload non-selected image");
      return;
    }
    if (!selectedFile) {
      setSelectedError("Please upload selected image");
      return;
    }

    window.scrollTo(0, 0);
    setSpin(true);

    try {
      const [nonSelectedUrl, selectedUrl, customUrl] = await Promise.all([
        uploadNonSelectedImage(nonSelectedFile),
        uploadSelectedImage(selectedFile),
        status && customFile ? uploadCustomImage(customFile) : Promise.resolve(""),
      ]);

      const data = {
        sortId: sort,
        name: name,
        images: [nonSelectedUrl, selectedUrl],
        description: description,
        subDescription: subDescription,
        custom: status,
        someField: status ? customUrl : "",
        createdBy: "60e9c7db11ab1428accf8278",
        updatedBy: "60e9c7db11ab1428accf8278",
        deletedBy: "60e9c7db11ab1428accf8278",
      };

      await axios.post(`${API}/category/add`, data);
      setShow(true);
      setSpin(false);
      setStatus(false);
      resetNonSelected();
      resetSelected();
      resetCustom();
      event.target.reset();
    } catch (err) {
      console.error(err.message);
      setSpin(false);
    }
  };

  return (
    <>
      {spin ? <Spinner /> : null}
      {show ? <Popup show={show} switch={change} message="Added Successfully" /> : null}
      <div className={styles.categorycontainer}>
        <div className={styles.heading}>
          <h1 className={styles.details}>Enter the Category Details</h1>
          <form onSubmit={saveData}>
            <div className={styles.items}>
              <div className={styles.first}>
                <p>Enter the Sort Id</p>
                <input
                  name='sortid'
                  placeholder='Sort ID'
                  type='number'
                  onChange={event => setSort(event.target.value)}
                  id={styles.gap}
                  required
                ></input>
              </div>
              <div className={styles.second}>
                <p>Enter the Category Name</p>
                <input
                  name='fullname'
                  placeholder='Category Name'
                  type='text'
                  onChange={event => setName(event.target.value)}
                  id={styles.gap}
                  required
                ></input>
              </div>

              <div className={styles.imageurl}>
                <p>Non-Selected Image</p>
                <div
                  className={styles.imageUploadDiv}
                  onClick={() => document.getElementById('nonSelectedInput').click()}
                >
                  {nonSelectedPreview ? (
                    <img src={nonSelectedPreview} alt="Non-Selected" className={styles.uploadedImage} />
                  ) : (
                    <span className={styles.uploadPlaceholder}>Click to upload non-selected image</span>
                  )}
                </div>
                <input
                  id="nonSelectedInput"
                  type="file"
                  accept="image/*,image/svg+xml"
                  onChange={handleNonSelectedFileChange}
                  style={{ display: "none" }}
                />
                {nonSelectedError && <p style={{ color: '#ef4444', fontSize: 14, marginTop: 6 }}>{nonSelectedError}</p>}
              </div>

              <div className={styles.selectedimageurl}>
                <p>Selected Image</p>
                <div
                  className={styles.imageUploadDiv}
                  onClick={() => document.getElementById('selectedInput').click()}
                >
                  {selectedPreview ? (
                    <img src={selectedPreview} alt="Selected" className={styles.uploadedImage} />
                  ) : (
                    <span className={styles.uploadPlaceholder}>Click to upload selected image</span>
                  )}
                </div>
                <input
                  id="selectedInput"
                  type="file"
                  accept="image/*,image/svg+xml"
                  onChange={handleSelectedFileChange}
                  style={{ display: "none" }}
                />
                {selectedError && <p style={{ color: '#ef4444', fontSize: 14, marginTop: 6 }}>{selectedError}</p>}
              </div>

              <div className={styles.fifth}>
                <p>Enter the Description</p>
                <textarea
                  name='fullname'
                  placeholder='Description'
                  type='text'
                  onChange={event => setDescription(event.target.value)}
                  id={styles.gapdesc}
                  required
                ></textarea>
              </div>
              <div className={styles.sixth}>
                <p>Enter the SubDescription</p>
                <textarea
                  name='fullname'
                  placeholder='Sub-Description'
                  type='text'
                  onChange={event => setSubDescription(event.target.value)}
                  id={styles.gapdesc}
                ></textarea>
              </div>
              <div className={styles.availability}>
                <p>Do you wanna allow Custom Products on this Category ?</p>
                <Toggle status={status} setStatus={setStatus} />
              </div>
              {status ? (
                <div className={styles.sixth}>
                  <p>Custom Image</p>
                  <div
                    className={styles.imageUploadDiv}
                    onClick={() => customRef.current?.click()}
                  >
                    {customPreview ? (
                      <img src={customPreview} alt="Custom" className={styles.uploadedImage} />
                    ) : (
                      <span className={styles.uploadPlaceholder}>Click to upload custom image</span>
                    )}
                  </div>
                  <input
                    ref={customRef}
                    type="file"
                    accept="image/*,image/svg+xml"
                    onChange={handleCustomFileChange}
                    style={{ display: "none" }}
                  />
                  {customError && <p style={{ color: '#ef4444', fontSize: 14, marginTop: 6 }}>{customError}</p>}
                </div>
              ) : null}
              <div className={styles.button}>
                <input
                  type='submit'
                  className={styles.bttn}
                  value='Submit'
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default CategoryAdd
